import React from 'react';

const Reso = () => {
  return (
    <div className="container mt-4">
      <h2 className="text-center mb-4">Reso365</h2>
      <div className="card">
        <div className="card-body">
          <h5 className="card-title">Reso 365</h5>
          <p className="card-text">
            Reso 365 is a dynamic goal-setting app designed to empower you to embrace positive change any day of the year. Whether you're starting a new habit or refining an existing one, Reso 365 offers an intuitive interface that makes personal growth accessible and enjoyable. Set your resolutions, track your progress, and celebrate every step towards a better version of yourself.
            <br /><br />
            <strong>Features:</strong>
          </p>
          <ul>
            <li>Create and update your resolutions anytime, no matter the season.</li>
            <li>Monitor your progress with clear, user-friendly charts and insights.</li>
            <li>Receive motivational reminders to keep you on track.</li>
            <li>Celebrate your milestones with personalized rewards.</li>
            <li>Access a supportive community to share your journey and inspire others.</li>
          </ul>
          <p className="card-text"><small className="text-muted">Privacy Policy</small></p>

          {/* Privacy Policy Content */}
          <div className="privacy-policy mt-4">
            <h3>Privacy Policy</h3>
            <p>
              This privacy policy applies to the Reso365 app (hereby referred to as <strong>"Application"</strong>) for mobile devices that was created by 4CY Game Studio (hereby referred to as <strong>"Service Provider"</strong>) as a Free service. This service is intended for use "AS IS".
            </p>

            <h4>Information Collection and Use</h4>
            <p>
              The Application collects information when you download and use it. This information may include information such as:
            </p>
            <ul>
              <li>Your device's Internet Protocol address (e.g. IP address)</li>
              <li>The pages of the Application that you visit, the time and date of your visit, the time spent on those pages</li>
              <li>The time spent on the Application</li>
              <li>The operating system you use on your mobile device</li>
            </ul>
            <p>
              The Application does not gather precise information about the location of your mobile device.
            </p>
            <p>
              The Application collects your device's location, which helps the Service Provider determine your approximate geographical location and make use of it in the following ways:
            </p>
            <ul>
              <li>
                <strong>Geolocation Services:</strong> The Service Provider utilizes location data to provide features such as personalized content, relevant recommendations, and location-based services.
              </li>
              <li>
                <strong>Analytics and Improvements:</strong> Aggregated and anonymized location data helps the Service Provider to analyze user behavior, identify trends, and improve the overall performance and functionality of the Application.
              </li>
              <li>
                <strong>Third-Party Services:</strong> Periodically, the Service Provider may transmit anonymized location data to external services. These services assist in enhancing the Application and optimizing their offerings.
              </li>
            </ul>
            <p>
              The Service Provider may use the information you provided to contact you from time to time to provide you with important information, required notices and marketing promotions.
            </p>
            <p>
              For a better experience, while using the Application, the Service Provider may require you to provide us with certain personally identifiable information, including but not limited to Email and <strong>resolutions</strong> (user-generated content). This content is encrypted to protect your privacy. The information that the Service Provider requests will be retained and used as described in this privacy policy.
            </p>

            <h4>Third Party Access</h4>
            <p>
              Only aggregated, anonymized data is periodically transmitted to external services to aid the Service Provider in improving the Application and their service. The Service Provider may share your information with third parties in the ways described in this privacy statement.
            </p>
            <p>
              Please note that the Application utilizes third-party services that have their own Privacy Policies about handling data. Below are the links to the Privacy Policies of the third-party service providers used by the Application:
            </p>
            <ul>
              <li>
                <a href="https://www.google.com/policies/privacy/" target="_blank" rel="noopener noreferrer">
                  Google Play Services
                </a>
              </li>
              <li>
                <a href="https://support.google.com/admob/answer/6128543?hl=en" target="_blank" rel="noopener noreferrer">
                  AdMob
                </a>
              </li>
              <li>
                <a href="https://firebase.google.com/support/privacy" target="_blank" rel="noopener noreferrer">
                  Google Analytics for Firebase
                </a>
              </li>
              <li>
                <a href="https://firebase.google.com/support/privacy" target="_blank" rel="noopener noreferrer">
                  Firebase Crashlytics
                </a>
              </li>
            </ul>
            <p>
              The Service Provider may disclose User Provided and Automatically Collected Information:
            </p>
            <ul>
              <li>as required by law, such as to comply with a subpoena, or similar legal process;</li>
              <li>when they believe in good faith that disclosure is necessary to protect their rights, protect your safety or the safety of others, investigate fraud, or respond to a government request;</li>
              <li>
                with their trusted services providers who work on their behalf, do not have an independent use of the information we disclose to them, and have agreed to adhere to the rules set forth in this privacy statement.
              </li>
            </ul>

            <h4>Opt-Out Rights</h4>
            <p>
              You can stop all collection of information by the Application easily by uninstalling it. You may use the standard uninstall processes available as part of your mobile device or via the mobile application marketplace or network.
            </p>

            <h4>Data Retention Policy</h4>
            <p>
              The Service Provider will retain User Provided data for as long as you use the Application and for a reasonable time thereafter. If you'd like them to delete User Provided Data that you have provided via the Application, please contact them at <a href="mailto:fourcygame@gmail.com">fourcygame@gmail.com</a> and they will respond in a reasonable time.
            </p>

            <h4>Children</h4>
            <p>
              The Service Provider does not use the Application to knowingly solicit data from or market to children under the age of 13.
            </p>
            <p>
              The Application does not address anyone under the age of 13. The Service Provider does not knowingly collect personally identifiable information from children under 13 years of age. In the event that the Service Provider discovers that a child under 13 has provided personal information, the Service Provider will immediately delete this from their servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact the Service Provider at <a href="mailto:fourcygame@gmail.com">fourcygame@gmail.com</a> so that they can take the necessary actions.
            </p>

            <h4>Security</h4>
            <p>
              The Service Provider is concerned about safeguarding the confidentiality of your information. The Service Provider provides physical, electronic, and procedural safeguards to protect the information it processes and maintains.
            </p>

            <h4>Changes</h4>
            <p>
              This Privacy Policy may be updated from time to time for any reason. The Service Provider will notify you of any changes to the Privacy Policy by updating this page with the new Privacy Policy. You are advised to consult this Privacy Policy regularly for any changes, as continued use is deemed approval of all changes.
            </p>

            <p>
              This privacy policy is effective as of <strong>2025-02-06</strong>
            </p>

            <h4>Your Consent</h4>
            <p>
              By using the Application, you are consenting to the processing of your information as set forth in this Privacy Policy now and as amended by us.
            </p>

         {/* Terms & Conditions Section */}
         <div className="terms-conditions mt-5">
            <h3>Terms & Conditions</h3>

            <h4>1. Acceptance of Terms</h4>
            <p>
              By downloading, accessing, or using Reso365 (the "Application"), you agree to these Terms & Conditions. If you do not agree, you must discontinue use of the Application.
            </p>

            <h4>2. Use of the Application</h4>
            <p>
              The Application is intended for personal use only. Unauthorized activities such as reverse-engineering, modifying, or distributing the Application without permission are strictly prohibited.
            </p>

            <h4>3. User-Generated Content</h4>
            <p>
              Users are responsible for any content (e.g., resolutions) they create within the Application. The Service Provider reserves the right to remove inappropriate content without notice.
            </p>

            <h4>4. Data Collection & Privacy</h4>
            <p>
              The Service Provider collects and processes user data as outlined in the <strong>Privacy Policy</strong>.
            </p>

            <h4>5. Service Modifications & Termination</h4>
            <p>
              The Service Provider reserves the right to modify, suspend, or discontinue the Application or its features at any time without prior notice. Users acknowledge that the Service Provider is not liable for any loss or inconvenience resulting from service interruptions or termination.
            </p>

            <h4>6. Limitation of Liability</h4>
            <p>
              The Service Provider provides the Application "AS IS" without warranties. The Service Provider is not liable for any data loss, technical issues, or damages resulting from use of the Application.
            </p>

            <h4>7. Third-Party Services</h4>
            <p>
              The Application integrates third-party services (e.g., Google Play Services, Firebase). The Service Provider is not responsible for data collection or privacy policies of these third-party providers.
            </p>

            <h4>8. Termination of Use</h4>
            <p>
              The Service Provider may suspend or terminate your access to the Application if you violate these Terms & Conditions. You may discontinue use by uninstalling the Application.
            </p>

            <h4>9. Governing Law</h4>
            <p>
              These Terms & Conditions are governed by the laws of [your country/jurisdiction] without regard to conflict of law principles.
            </p>

            <h4>10. Contact</h4>
            <p>
              For inquiries regarding these Terms & Conditions, contact us at <a href="mailto:fourcygame@gmail.com">fourcygame@gmail.com</a>.
            </p>

          
          
          <br></br>
          </div>
            <p>
              <em>
                This privacy policy page was generated by{' '}
                <a
                  href="https://app-privacy-policy-generator.nisrulz.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  App Privacy Policy Generator
                </a>
              </em>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reso;